import React, { createContext, useEffect, useState } from 'react';
import axios from 'axios';
import {API_URL} from '../constants';
import {AXIOS_NOT_FOUND_REDIRECT_OPT_OUT} from '../axiosNotFoundRedirect';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [token, setToken] = useState(localStorage.getItem('authToken'));
    const [admin, setAdmin] = useState(() => {
        // Get admin data from local storage or set to null if not available
        const savedAdmin = localStorage.getItem('adminData');
        return savedAdmin ? JSON.parse(savedAdmin) : null;
    });
    const [whitelabelsById, setWhitelabelsById] = useState({});

    useEffect(() => {
        setToken(localStorage.getItem('authToken'));
    }, []);

    // Sync admin data if it's expected to change
    useEffect(() => {
        if (admin) localStorage.setItem('adminData', JSON.stringify(admin));
        else localStorage.removeItem('adminData');
    }, [admin]);

    useEffect(() => {
        let active = true;

        if (!token) {
            setWhitelabelsById({});
            return () => {
                active = false;
            };
        }

        setWhitelabelsById({});
        axios.get(`${API_URL}/api/admin/whitelabels/options`, {
            ...AXIOS_NOT_FOUND_REDIRECT_OPT_OUT,
            headers: {Authorization: `Bearer ${token}`},
        }).then((response) => {
            if (!active) return;

            const options = response.data.data || [];
            setWhitelabelsById(Object.fromEntries(
                options.map((whitelabel) => [String(whitelabel.id), whitelabel])
            ));
        }).catch(() => {
            if (active) setWhitelabelsById({});
        });

        return () => {
            active = false;
        };
    }, [token]);

    const hasRole = (role) => {
        if (!admin || !admin.roles) return false;
        return admin.roles.some(p => p.name === role);
    };

    const hasPermission = (permission) => {
        if (!admin || !admin.roles) return false;
        for (const role of admin.roles) {
            if (role.permissions.some(p => p.name === permission)) {
                return true;
            }
        }
        return false;
    };

    return (
        <AuthContext.Provider value={{ token, setToken, admin, setAdmin, hasRole, hasPermission, whitelabelsById }}>
            {children}
        </AuthContext.Provider>
    );
};
